import { render, staticRenderFns } from "./SessionSummary.vue?vue&type=template&id=2aa6b450&scoped=true"
import script from "./SessionSummary.vue?vue&type=script&lang=js"
export * from "./SessionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa6b450",
  null
  
)

export default component.exports